/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ visit: NonNullable<unknown>, due: NonNullable<unknown> }} Due_Payments_VisitInputs */

const en_due_payments_visit = /** @type {(inputs: Due_Payments_VisitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Visit ${i?.visit} · pay by ${i?.due}`)
};

const pl_due_payments_visit = /** @type {(inputs: Due_Payments_VisitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wizyta ${i?.visit} · zapłata do ${i?.due}`)
};

/**
* | output |
* | --- |
* | "Visit {visit} · pay by {due}" |
*
* @param {Due_Payments_VisitInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const due_payments_visit = /** @type {((inputs: Due_Payments_VisitInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Due_Payments_VisitInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_due_payments_visit(inputs)
	return en_due_payments_visit(inputs)
});